const getters = {
    // language: (state) => state.settings.language
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js